export default __webpack_public_path__ + "a0fea1c6f4741648523c32df459e6dbf.jpg";